import { vars } from '@theme'

export const SPACE_VARIANTS = {
    none: vars.space.none,
    px: vars.space.px,
    xxs: vars.space.xxs,
    xs: vars.space.xs,
    xs2: vars.space.xs2,
    sm: vars.space.sm,
    sm2: vars.space.sm2,
    md: vars.space.md,
    md2: vars.space.md2,
    lg: vars.space.lg,
    lg2: vars.space.lg2,
    xl: vars.space.xl,
    '2xl': vars.space['2xl'],
    '3xl': vars.space['3xl'],
    '4xl': vars.space['4xl'],
    '5xl': vars.space['5xl'],
} as const
